var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 20.0247C3.33398 11.2449 10.3507 3.33301 20.034 3.33301C29.5007 3.33301 36.6673 11.0947 36.6673 19.9746C36.6673 30.2734 28.2673 36.6663 20.0007 36.6663C17.2673 36.6663 14.234 35.9319 11.8007 34.4964C10.9507 33.979 10.234 33.5951 9.31732 33.8955L5.95065 34.897C5.10065 35.1641 4.33398 34.4964 4.58398 33.5951L5.70065 29.8561C5.88398 29.3387 5.85065 28.7879 5.58398 28.3539C4.15065 25.7166 3.33398 22.8289 3.33398 20.0247ZM17.834 20.0247C17.834 21.2098 18.784 22.1612 19.9673 22.1779C21.1507 22.1779 22.1007 21.2098 22.1007 20.0414C22.1007 18.8563 21.1507 17.9049 19.9673 17.9049C18.8007 17.8882 17.834 18.8563 17.834 20.0247ZM25.5173 20.0414C25.5173 21.2098 26.4673 22.1779 27.6507 22.1779C28.834 22.1779 29.784 21.2098 29.784 20.0414C29.784 18.8563 28.834 17.9049 27.6507 17.9049C26.4673 17.9049 25.5173 18.8563 25.5173 20.0414ZM12.284 22.1779C11.1173 22.1779 10.1507 21.2098 10.1507 20.0414C10.1507 18.8563 11.1007 17.9049 12.284 17.9049C13.4673 17.9049 14.4173 18.8563 14.4173 20.0414C14.4173 21.2098 13.4673 22.1612 12.284 22.1779Z",
    fill: "#9610FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.c463056eae1b2221b0f0932acbe2733e.svg";